module.exports = __webpack_public_path__ + "static/media/light.193cb1bb.png";